import React from "react";

// Glossy black Swiss cross with subtle highlight — used as brand mark.
export const GlossyCross = ({ size = 64, className = "" }) => {
  const s = size;
  return (
    <svg
      width={s}
      height={s}
      viewBox="0 0 100 100"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="glossy-black" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#3a3a3a" />
          <stop offset="35%" stopColor="#1c1c1c" />
          <stop offset="55%" stopColor="#0e0e0e" />
          <stop offset="100%" stopColor="#050505" />
        </linearGradient>
        <linearGradient id="glossy-highlight" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="rgba(255,255,255,0.35)" />
          <stop offset="45%" stopColor="rgba(255,255,255,0.05)" />
          <stop offset="100%" stopColor="rgba(255,255,255,0)" />
        </linearGradient>
        <filter id="cross-shadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="2" stdDeviation="3" floodColor="#000" floodOpacity="0.6" />
        </filter>
      </defs>
      {/* Swiss cross geometry — arms are ~1/6 of full width */}
      <g filter="url(#cross-shadow)">
        <path
          d="M40 15 H60 V40 H85 V60 H60 V85 H40 V60 H15 V40 H40 Z"
          fill="url(#glossy-black)"
          stroke="#2a2a2a"
          strokeWidth="0.5"
        />
        {/* Top highlight to sell the "glossy" feel */}
        <path
          d="M41 16 H59 V39 H84 V49 H60 V50 H40 V50 H16 V41 H40 V16 Z"
          fill="url(#glossy-highlight)"
          opacity="0.55"
        />
      </g>
    </svg>
  );
};

export default GlossyCross;
